import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import '../../assets/style/splash_view.css'
import Colors from 'utils/colors'

const SplashScreen = () => {
  const navigate = useNavigate()
  const { id } = useParams()

  useEffect(() => {
    const timer = setTimeout(() => {
      if(id){
        navigate('/activity', { state: { id: id } })
      }
    }, 3000)

    return () => clearTimeout(timer)
  }, [id, navigate])

  return (
    <div className="splash-container" style={styles.container}>
      <img src={'/images/cine-yelmo.png'} alt="Yelmo" style={styles.image} className="child" />
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: `linear-gradient(180deg, ${Colors.primary} 0%, ${Colors.secondary} 58.8%, ${Colors.black} 117.6%)`,
  },
  image: {
    maxWidth: '60%',
    maxHeight: '60%',
    objectFit: 'contain',
  },
}

export default SplashScreen
